// * https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement

export default function loadScript(url, id) {
  return new Promise((resolve, reject) => {
    // * don't load twice (detect via id)
    if (id) {
      const oldScript = document.getElementById(id)
      if (oldScript) {
        return resolve()
      }
    }

    const newScript = document.createElement('script')
    newScript.onerror = reject
    newScript.onload = resolve
    newScript.async = true
    if (id) {
      newScript.id = id
    }
    document.head.appendChild(newScript)
    newScript.src = url
  })
}
